/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemStreemshotRequestFromJSON(json) {
    return WallItemStreemshotRequestFromJSONTyped(json, false);
}
export function WallItemStreemshotRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'streemshotId': !exists(json, 'streemshot_id') ? undefined : json['streemshot_id'],
        'requestedOfUserId': !exists(json, 'requested_of_user_id') ? undefined : json['requested_of_user_id'],
        'requestedOfDeviceId': !exists(json, 'requested_of_device_id') ? undefined : json['requested_of_device_id'],
    };
}
export function WallItemStreemshotRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'streemshot_id': value.streemshotId,
        'requested_of_user_id': value.requestedOfUserId,
        'requested_of_device_id': value.requestedOfDeviceId,
    };
}
//# sourceMappingURL=WallItemStreemshotRequest.js.map